import { uuid } from './regex';

export const RentalRoutes = {
    path: 'rental',
    landlord: {
        path: 'landlord',
        new: {
            path: 'new',
        },
        details: {
            path: ':landlordId(\\d+)',
            verification: {
                path: 'verification',
                account: {
                    path: `:externalAccountId(${uuid})`,
                },
            },
            disableAccount: {
                path: 'disableAccount',
                account: {
                    path: `:externalAccountId(${uuid})`,
                },
            },
            newAccount: {
                path: 'newAccount',
            },
            edit: {
                path: 'edit',
            },
        },
    },
    billings: {
        path: 'billings',
    },
    contract: {
        path: `:contractId(${uuid})`,
        billings: {
            path: 'billings',
            details: {
                path: `:billingId(${uuid}|\\d+)`,
                split: {
                    path: 'split',
                },
                edit: {
                    path: 'edit',
                },
            },
            new: {
                path: 'new',
            },
        },
        files: {
            path: 'files',
            new: {
                path: 'new',
            },
            details: {
                path: ':fileSeedId',
            },
        },
        splits: {
            path: 'splits',
            edit: {
                path: 'edit',
            },
            new: {
                path: 'new',
            },
            details: {
                path: `:splitId(${uuid})`,
                edit: {
                    path: 'edit',
                },
            },
        },
        charges: {
            path: 'charges',
            billings: {
                path: 'billings',
                edit: {
                    path: 'edit',
                    destinations: {
                        path: 'destinations',
                    },
                },
            },
            split: {
                path: 'split',
                fixed: {
                    path: 'fixed',
                    new: {
                        path: 'new',
                    },
                    details: {
                        path: `:splitChargeId(\\d+)`,
                        edit: {
                            path: 'edit',
                        },
                    },
                },
                installments: {
                    path: 'installments',
                    new: {
                        path: 'new',
                    },
                    details: {
                        path: `:splitChargeId(\\d+)`,
                        edit: {
                            path: 'edit',
                        },
                    },
                },
                edit: {
                    path: 'edit',
                    destinations: {
                        path: 'destinations',
                    },
                },
            },
        },
        parties: {
            path: 'parties',
            edit: {
                path: 'edit',
                landlord: {
                    path: 'landlord',
                    new: {
                        path: 'editLandlord',
                    },
                },
                tenants: {
                    path: 'tenants',
                },
            },
        },
        address: {
            path: 'address',
            edit: {
                path: 'edit',
            },
        },
        rentAdjustment: {
            path: 'rentAdjustment',
            history: {
                path: 'history',
                edit: {
                    path: ':historyId(\\d+)',
                },
            },
        },
        settings: {
            path: 'settings',
            edit: {
                path: 'edit',
                rental: {
                    path: 'rental',
                },
                split: {
                    path: 'split',
                },
            },
        },
    },
    new: {
        path: 'new',
    },
    kyc: {
        path: 'kyc',
        fill: {
            path: 'fill',
        },
        notOwner: {
            path: 'notOwner',
        },
    },
    splits: {
        path: 'splits',
        destinationChart: {
            path: 'destination',
        },
        details: {
            path: `:splitId(${uuid})`,
            edit: {
                path: 'edit',
            },
        },
    },
    explain: {
        path: 'explain',
        lp: { path: ':lp' },
    },
    training: {
        path: 'training',
    },
};
